import { render, staticRenderFns } from "./GeneralConsentForm.vue?vue&type=template&id=3a55c4f7&scoped=true"
import script from "./GeneralConsentForm.vue?vue&type=script&lang=js"
export * from "./GeneralConsentForm.vue?vue&type=script&lang=js"
import style0 from "./GeneralConsentForm.vue?vue&type=style&index=0&id=3a55c4f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a55c4f7",
  null
  
)

export default component.exports